import { Commit, ActionTree, Dispatch } from 'vuex';
import graphQl from '../../../../services/graphQl';
import axios, { AxiosPromise, AxiosResponse } from 'axios';
import actions from './profile.actions';
import mutations from './profile.mutations';
import getters from './profile.getters';

import {
  IOption,
  ITaskOptions,
  TaskSourceType,
  TaskListSourceType,
  TracesSourceType,
  IHeaderSource
} from './profile.d';
import {
  InitTaskField,
  InitTaskFieldSource,
  ChangeTaskOpt
} from './profile-constant';

export interface State {
  headerSource: IHeaderSource;
  newTaskFields: ITaskOptions;
  taskFieldSource: TaskSourceType;
  taskListSource: TaskListSourceType[];
  taskListTotal: Number;
  taskId: any;
  segmentSpans: any[];
  currentSegment: any;
  segmentList: any;
  profileAnalyzation: any;
  highlightTop: boolean;
  currentSpan: any;
  includeChildren: boolean;
}

const initState: State = {
  headerSource: {
    serviceSource: [{ key: '', label: 'None' }],
    currentService: { key: '', label: 'None' },
    endPointService: [{ key: '', label: '' }],
    currentEndpoint: { key: '', label: '' }
  },
  newTaskFields: InitTaskField,
  taskFieldSource: InitTaskFieldSource,
  taskListSource: [],
  taskListTotal: 0,
  taskId: '',
  segmentSpans: [],
  currentSegment: {
    operationNames: [],
    duration: 0,
    isError: false,
    key: '',
    start: '',
    traceIds: []
  },
  segmentList: [],
  profileAnalyzation: [],
  highlightTop: true,
  currentSpan: {},
  includeChildren: true
};

export default {
  namespaced: true,
  state: initState,
  getters,
  actions: actions,
  mutations: mutations
};
